// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 元数据基类 实体类
 * 所有元数据的基类
 */
export abstract class BaseElement extends BaseEntity {
  /** 设计期ID : 设计期ID */
  private _designId: string;

  /** 设置：设计期ID */
  public get designId() {
    return this._designId;
  }

  /** 获取：设计期ID */
  public set designId(value: string) {
    this._designId = value;
  }

  /** 名称 : 元数据名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 显示名称 : 元数据的显示名称 */
  private _displayName: string;

  /** 设置：显示名称 */
  public get displayName() {
    return this._displayName;
  }

  /** 获取：显示名称 */
  public set displayName(value: string) {
    this._displayName = value;
  }

  /** 描述 : 元数据的描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 顺序号 : 顺序号，默认升序，用于控制一组元素的先后顺序 */
  private _sequence: number;

  /** 设置：顺序号 */
  public get sequence() {
    return this._sequence;
  }

  /** 获取：顺序号 */
  public set sequence(value: number) {
    this._sequence = value;
  }

  constructor() {
    super();
    this._designId = '';
    this._name = '';
    this._displayName = '';
    this._description = '';
    this._sequence = 0;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseElement, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.designId = element.designId;
      this.name = element.name;
      this.displayName = element.displayName;
      this.description = element.description;
      this.sequence = element.sequence;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.designId = json.DesignId;
    this.name = json.Name;
    this.displayName = json.DisplayName;
    this.description = json.Description;
    this.sequence = json.Sequence;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DesignId = this.designId;
    json.Name = this.name;
    json.DisplayName = this.displayName;
    json.Description = this.description;
    json.Sequence = this.sequence;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('基本属性', 'name', '名称', EnumDataType.String, this.name, true, '元数据名称', '', '');
    context.addRow('基本属性', 'displayName', '显示名称', EnumDataType.String, this.displayName, true, '元数据的显示名称', '', '');
    context.addRow('基本属性', 'description', '描述', EnumDataType.String, this.description, true, '元数据的描述', '', '');
  }
}
